export default __webpack_public_path__ + "static/media/img_post6_2.87a07994.png";